<template>
  <div class="all">
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" type="index" width="60" />
        <el-table-column label="字段名称" prop="colCnName" min-width="200px" />
        <el-table-column label="类型" prop="typeId">
          <template slot-scope="scope">
            <span v-if="scope.row.typeId == '1'">输入值</span>
            <span v-if="scope.row.typeId == '2'">选择人员</span>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" prop="isShow">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow == 1">显示</span>
            <span v-if="scope.row.isShow == 0">不显示</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="dataOrder" />
        <el-table-column label="创建人" prop="createUserName" />
        <el-table-column label="添加时间" prop="createTime" min-width="120px" />
      </el-table>
    </div>
    <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData"></page>
  </div>
</template>
<script>
import request from "@/CommonDP/service/frame-service";
import page from "@/CommonDP/components/paging";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      upload: false,
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    // 列表
    async getList(index = 1) {
      this.loading = true;
      const {
        page: { pageSize },
        enterpriseId
      } = this;
      const params = { pageNum: index, pageSize, enterpriseId };
      const { data, pageNum, totalCount } = await request.frameCustomizationList(params);
      this.tableData = data;
      this.page.pageNum = pageNum;
      this.page.totalCount = totalCount;
      this.loading = false;
    },
    fetchData(val) {
      this.getList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.header-top {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  height: 50px;
  padding: 10px;
  .header_b {
    margin-top: 10px;
    margin-left: 20px;
  }
}
.midd {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 50px;
  padding: 4px 10px;
}
.page-2 {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
